import React, { useEffect, useState } from "react";
import classes from "./FreeMediaDragSection.module.css";
import { motion } from "framer-motion";
import MovieCard from "./MovieCard";
import { useNavigate } from "react-router-dom";

const FreeMediaDragSection = ({
  data,
  media_type,
}: {
  data: any;
  media_type: "movies" | "series";
}) => {
  const [windowWidth, setWindowWidth] = useState<number>(0);

  useEffect(() => {
    const updateConstraints = () => {
      setWindowWidth(window.innerWidth);
    };

    updateConstraints();
    window.addEventListener("resize", updateConstraints);

    return () => {
      window.removeEventListener("resize", updateConstraints);
    };
  }, []);

  const navigate = useNavigate();
  const [startPosition, setStartPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);

  const handleMouseDown = (event: React.MouseEvent<HTMLButtonElement>) => {
    setStartPosition({ x: event.clientX, y: event.clientY });
    setIsDragging(false);
  };

  const handleMouseUp = (
    event: React.MouseEvent<HTMLButtonElement>,
    data: any
  ) => {
    const distance = Math.sqrt(
      Math.pow(event.clientX - startPosition.x, 2) +
        Math.pow(event.clientY - startPosition.y, 2)
    );
    if (distance < 5 && !isDragging) {
      if (media_type === "movies") {
        navigate(`/movies/${data?.id}/${data?.title ?? data?.name}`);
      } else {
        navigate(`/series/${data?.id}/${data?.title ?? data?.name}`);
      }
    }
  };

  const handleMouseMove = () => {
    setIsDragging(true);
  };

  return (
    <motion.div
      className={classes.section_card}
      style={{
        gridTemplateColumns: `repeat(${data?.result?.length}, 150px)`,
      }}
      drag="x"
      dragConstraints={{
        top: 0,
        left: -(windowWidth <= 800
          ? 10 +
            data?.result?.length * 150 +
            data?.result?.length * 10 +
            data?.result?.length * 1 -
            windowWidth
          : window.innerWidth * 0.05 +
            data?.result?.length * 150 +
            data?.result?.length * 10 +
            data?.result?.length * 1 -
            windowWidth),
        right: 0,
        bottom: 0,
      }}
      transition={{
        type: "spring",
        damping: 100,
        stiffness: 100,
      }}
    >
      {data?.result?.map((dataItem: any, idx: number) => (
        <button
          className={classes.main_card}
          onMouseDown={(event) => handleMouseDown(event)}
          onMouseUp={(event) => handleMouseUp(event, dataItem)}
          onMouseMove={handleMouseMove}
          key={idx}
        >
          <div className={classes.main_card_image}>
            <img
              src={`${dataItem?.image}`}
              alt="movie"
              className={classes.main_card_img}
            />
          </div>
          <div className={classes.main_card_content}>
            <p className={classes.main_card_title}>{dataItem?.name}</p>
          </div>
        </button>
      ))}
    </motion.div>
  );
};

export default FreeMediaDragSection;
